<template>
  <div class="information">
    <div class="inner">
      <div class="nav" v-if="clientWidth > 900">
        <el-tabs v-model="news_type" @tab-click="handleClick">
          <el-tab-pane :label="$t('遊戲视频')" :name="'1'"></el-tab-pane>
          <el-tab-pane :label="$t('遊戲地圖')" :name="'2'"></el-tab-pane>
          <el-tab-pane :label="$t('遊戲指南')" :name="'3'"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="mobile-nav" v-else>
        <div
          :class="news_type === item.value ? 'nav-active' : 'mobile-nav-item'"
          v-for="(item, index) in navData"
          @click="mobileHandleClick(item)"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <videos v-if="news_type === '1'" />
      <maps v-if="news_type === '2'" />
      <guide v-if="news_type === '3'" />
    </div>
  </div>
</template>
<script>
import videos from "./components/videos";
import guide from "./components/guide";
import maps from "./components/map";
import { mapState } from "vuex";
export default {
  components: {
    videos,
    guide,
    maps,
  },
  data() {
    return {
      news_type: "1",
      navData: [
        {
          name: this.$t("遊戲视频"),
          value: "1",
        },
        {
          name: this.$t("遊戲地圖"),
          value: "2",
        },
        {
          name: this.$t("遊戲指南"),
          value: "3",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      type: (state) => state.header.currentTpye,
      clientWidth: (state) => state.screen.clientWidth,
    }),
  },
  watch: {
    type(newVal) {
      this.news_type = newVal;
    },
  },
  mounted() {
    this.news_type = this.$store.state.header.currentTpye || "1";
  },
  methods: {
    handleClick() {},
    mobileHandleClick(item) {
      this.news_type = item.value;
    },
  },
};
</script>
<style lang="scss" scoped>
.information {
  box-sizing: border-box;
  padding: 40px 0;
  background-image: url("~@/assets/img/home/bg_currency.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  min-height: 80vh;
  .inner {
    width: 1200px;
    margin: 0 auto;
    @media only screen and (max-width: 900px) {
      box-sizing: border-box;
      width: 90%;
    }
    .nav {
      margin-bottom: 40px;
    }
    .mobile-nav {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      @media only screen and (max-width: 900px) {
        margin-bottom: 20px;
        font-size: 14px;
      }
      &-item {
        @media only screen and (max-width: 900px) {
          flex: 1;
          text-align: center;
          height: 40px;
          line-height: 40px;
        }
      }
      .nav-active {
        @media only screen and (max-width: 900px) {
          flex: 1;
          text-align: center;
          height: 40px;
          line-height: 40px;
          color: #c6a86c;
          border-bottom: 2px solid #c6a86c;
        }
      }
    }
  }
}
::v-deep .is-top::after {
  background-color: transparent;
}
::v-deep .is-active {
  color: #c6a86c;
}
::v-deep .el-tabs__active-bar {
  background-color: #c6a86c;
  height: 3px;
}
::v-deep .el-tabs__item {
  &:hover {
    color: #c6a86c;
  }
  font-size: 18px;
}
</style>
